/* eslint-disable max-statements */
import {IntlShape} from 'react-intl';
import {fromByteArray} from 'base64-js';

// 获取设备信息
function getWindowsSystem(sysVersionStr: string) {
    let sysVersion = sysVersionStr;
    switch (sysVersionStr) {
        case '5.1':
        case '5.2':
            sysVersion = 'xp';
            break;
        case '6.0':
            sysVersion = 'Vista';
            break;
        case '6.1':
            sysVersion = '7';
            break;
        case '6.2':
        case '6.3':
            sysVersion = '8';
            break;
        case '10.0':
            sysVersion = '10';
            break;
        default:
            sysVersion = 'NT ' + sysVersionStr;
            break;
    }
    return sysVersion;
}

export function getDevice() {
    const ua = window.navigator.userAgent;
    let device = '';
    let platform = '';
    let sys: any = [];
    if (/Android/ig.test(ua)) {
        device = 'Android'; // Android 智能手机
        platform = 'mobile';
        sys = /(Android)\s+([0-9.]*)/ig.exec(ua);
    }
    else if (/iPhone/ig.test(ua)) {
        device = 'iPhone'; // iphone
        platform = 'mobile';
        sys = /(iPhone OS)\s+([0-9_]*)/ig.exec(ua);
        sys[2] = sys[2].split('_').join('.');
    }
    else if (/iPad/ig.test(ua)) {
        device = 'iPad'; // iphone
        platform = 'mobile';
        sys = /(OS)\s+([0-9_]*)/ig.exec(ua);
        sys[2] = sys[2].split('_').join('.');
    }
    else if (/Macintosh/ig.test(ua)) {
        device = 'Mac'; // mac
        platform = 'desktop';
        sys = /(Mac OS X)\s+([0-9_]*)/ig.exec(ua);
        sys[2] = sys[2].split('_').join('.');
    }
    else if (/Windows/ig.test(ua)) {
        device = 'Windows'; // windows
        platform = 'desktop';
        sys = /(Windows) NT ([0-9.]*)/ig.exec(ua);
        sys[2] = getWindowsSystem(sys[2]);
    }
    else if (/OhosPad/g.test(ua)) {
        device = 'OhosPad'; // 鸿蒙平板
        platform = 'mobile';
        sys = /SysVersion\/([\d.]+)/ig.exec(ua);
    }
    else if (/Ohos/g.test(ua)) {
        device = 'Ohos'; // 鸿蒙手机
        platform = 'mobile';
        sys = /SysVersion\/([\d.]+)/ig.exec(ua);
    }
    return {
        device: device,
        system: sys ? sys[1] : undefined,
        platform: platform,
        sysVersion: sys ? sys[2] : undefined,
    };
}

export function isHi() {
    const userAgent = window.navigator.userAgent;
    return /Infoflow|baiduhi_android|baiduhi_ios|machi|minihi/gi.test(userAgent);
}

// hi.open 打开好友,群,讨论组,服务号聊天窗口
export function hiOpenChat(rlName?: string, rlId?: string) {
    try {
        window.BdHiJs.service.hi.open({
            data: {
                bdid: rlName || '', // 好友场景且id未知时使用该参数，值为对方的hi用户名
                id: rlId || '', // String，人/群/讨论组/服务号的 imid，可以传空字符串，但字段不能不传
                type: '1', // String，0未知（群聊助手、服务号盒子等）1 人（好友、同事） 2 群 3 讨论组 4 服务号
            },
            onfail: (err: any) => {
                console.log(err?.error);
            },
        });
    } catch (e) {
        console.log(e);
    }
}

export function openInfoFlowBySDK(url: string, groupID?: string, defaultSize?: string) {
    console.log('日志：调用端上SDK调起窗口-----', url);
    try {
        window.BdHiJs.appnative.webview.loadURL({
            data: {
                type: 'separate', // separate：应用内独立窗口打开；system：使用系统浏览器打开，tab：使用tab方式打开新页面
                groupID: groupID || '', // String, 可选，分组。支持 tab 和 separate 方式，如果分组相同，会使用同一个页面加载 url
                defaultSize: defaultSize || '960,640', // String, 可选，对 separate 有效，独立窗口的默认尺寸，"宽,高"
                minSize: '100,100', // String, 可选，对 separate 有效，独立窗口的最小尺寸，"宽,高"
                sizeFixed: false, // Boolean, 可选，不填为false，对 separate 有效。true：独立窗口禁用最大化和窗口拖拽
                canGoBack: true, // Boolean, 可选，不填为true，仅对 windows端separate 有效。false：独立窗口屏蔽左上角返回按钮
                canRefresh: true, // Boolean, 可选，不填为true，仅对 windows端separate 有效。false：独立窗口屏蔽右上角刷新按钮
                canPin: true, // Boolean, 可选，不填为true，仅对 windows端separate 有效。false：独立窗口屏蔽右上角置顶按钮
                titleAnchor: 0, // 标题对齐方式，UINT，可选 不填为0，仅对 windows端separate 有效。
                naviStyle: 0, // 导航栏样式 UINT,可选，不填为0，仅对 windows端separate 有效  桌面端BdHiJs.sdk.version.get() >= 37 新增支持,
                url,
            },
        });
    } catch (e) {
        console.log(e);
    }
}

export function openInSystemBrowser(url: string) {
    console.log('kuShare日志：openInSystemBrowser-------------------', url);
    try {
        window.BdHiJs.appnative.webview.loadURL({
            data: {
                url,
                type: 'system',
            },
        });
    } catch (e) {
        console.error(e);
        console.log('kuShare日志：端内打开url失败----------------------', e);
        window.open(url);
    }
}

export function setDocumentTitle(title: string | null | undefined, intl?: IntlShape) {
    let str = title;
    if (typeof str !== 'string' && intl) {
        str = intl.formatMessage({id: 'title'});
    }
    window.document.title = str as string;
}

// 解决window.open打开新窗口的时候被拦截
export function openUrlOnNewWindow(url: string) {
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('target', '_blank');
    // 防止反复添加
    a.click();
    a.remove();
}

// 下载功能公共组件（包含部门知识库的知识库下载、统计下的数据总览列表及数据明细列表下载、我管理的部门下载、已读未读公告下载）
// fileName为文档的标题，data为数据。
export function downloadCommon(fileName : string, data: any) {
    // 下载文件流
    const ele = document.createElement('a');// 创建下载链接
    ele.style.display = 'none';// 隐藏的可下载链接
    ele.href = URL.createObjectURL(data);
    document.body.appendChild(ele);
    ele.setAttribute('download', `${fileName}.xlsx`);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
}

export const compile = (apiString: string) => {
    const url = new URL('infoflow://APICenter');
    const byteArray = new TextEncoder().encode(apiString);
    // 转base64编码
    const apiBase64 = fromByteArray(byteArray);
    // 转url编码
    const apiEncode = encodeURIComponent(apiBase64);
    // 设置data参数 拼接url
    const queryString = `data=${apiEncode}`;
    const finalUrl = `${url.href}?${queryString}`;
    return finalUrl;
};

/**
* 打开如流群聊
*
* @param groupId 群组ID
*/
export const openRuliuGroup = (groupId: string) => {
    const data: any = {
        APIName: 'BdHiJs.service.hi.open',
        version: '65',
        data: {
            id: groupId,
            type: '2',
            source: '1',
            appname: '知识库',
        },
    };

    const openUrl = compile(JSON.stringify(data));
    window.open(openUrl);
};
